var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-nav',[_c('b-nav-item',{attrs:{"to":{name: 'register'}}},[_vm._v("Registrieren")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{name: 'login'}}},[_vm._v("Login")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{name: 'imprint'}}},[_vm._v("Impressum")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2df63cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/Guests.vue
// module id = 801
// module chunks = 1